import React from 'react';
import './SurveysFeatureList.css';
import {data} from './data';

function SurveysFeatureList() {

    return (
        <div>
            <section className="surveys-feature-list">
                <div className="surveys-feature-list-container">
                    {data?.map((feature, index) => {
                        return (
                            <div key={index} className={"surveys-feature-list-features " + feature.position}>
                                <div className="surveys-feature ">
                                    <img src={feature.image} alt="feature"/>
                                </div>
                                <div className="surveys-feature">
                                    <h2>{feature.title}</h2>
                                    <p>{feature.description}</p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </section>
        </div>
    );
}

export default SurveysFeatureList;
